/* eslint-disable unicorn/numeric-separators-style */

/* Example BUG_BOUNTY_PARTICIPANTS constant filled with dummy values */
// export const BUG_BOUNTY_PARTICIPANTS: BugBountyParticipants = {
//   '1212495': {
//     vendorId: 1211528,
//     hosting: {
//       cloud: true,
//       server: false,
//       dataCenter: false,
//     }
//   },
//   '1216387': {
//     vendorId: 1213911,
//     hosting: {
//       cloud: true,
//       server: true,
//       dataCenter: false,
//     }
//   }
// };

/* Make changes in this constant to add/remove participating apps */
export const BUG_BOUNTY_PARTICIPANTS = {
  'Addteq.Excellentable': {
    vendorId: 1210688,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'aa.analytics': {
    vendorId: 1216058,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ac-copy-space': {
    vendorId: 84,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'acceptance-criteria-free': {
    vendorId: 1215166,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'agile.estimation.3.0_private': {
    vendorId: 1211528,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ai-insights-ace': {
    vendorId: 1210584,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'amoeboids-upraise': {
    vendorId: 1211499,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'amoeboids.embedder': {
    vendorId: 1211499,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'amoeboids.employeegarrison': {
    vendorId: 1211499,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'amoeboids.people': {
    vendorId: 1211499,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'amoeboids.releasenotes': {
    vendorId: 1211499,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'andreymarkelov-atlas-plugins.templator': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'app.adobexd.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.airtables.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.conversation.jira': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.customlinks.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.adobepdf': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.bundles.design': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.bundles.presentation': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.calendly': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.canva': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.deepnote': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.framer': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.geckoboard': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.github': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.gslides': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.hotjar': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.keynote': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.marvel': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.miro': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.netlify': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.octopus': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.pitch': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.protopie': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.embedder.zeplin': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.figma.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.figma.confluence.lite': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.figma.jira': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.framerx.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.jxl': {
    vendorId: 1219648,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.radbee.jira.speedy-pdf': {
    vendorId: 1216508,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.releasemanagement.releasegadgets.release-gadget': {
    vendorId: 1216961,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'app.releasemanagement.rmcloud': {
    vendorId: 1216961,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.wordart.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'app.yellownotes.confluence': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'aptis.plugins.epicSumUp': {
    vendorId: 1211721,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'asana-gadgets-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'asana-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'async-poker': {
    vendorId: 1217333,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-gmail-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-jira-training': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'atlassian-outlook-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-playbook-daci-decision': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-playbook-experience-canvas': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-playbook-leadership-team-health-monitor': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-playbook-project-poster': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-playbook-project-team-health-monitor': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-playbook-service-team-health-monitor': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'atlassian-plugin-sdk-deb': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'atlassian-plugin-sdk-mac': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'atlassian-plugin-sdk-rpm': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'atlassian-plugin-sdk-tgz': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'atlassian-plugin-sdk-windows': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'atlassian.bitbucket.server.jenkins.integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'awssc-jsd-connector': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'azure-devops-confluence-integration': {
    vendorId: 1213354,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'azuredevopsnode.exalate.cloud': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'bg.nemetschek.jsd.advance-customer-reports': {
    vendorId: 1212521,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'bg.nemetschek.pmaddon.timeline': {
    vendorId: 1212521,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'biz.artemissoftware.confluence.html.HtmlMacro': {
    vendorId: 84,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'biz.artemissoftware.confluence.multiexcerpt.MultiExcerptMacro': {
    vendorId: 84,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'biz.artemissoftware.confluence.storage.StorageEditor': {
    vendorId: 84,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'biz.epicreport.epicreports': {
    vendorId: 1213040,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'biz.epicreport.worklogs': {
    vendorId: 1213040,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'box-connector-addon-plugin-for-confluence-topdox': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'box-gadgets-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'box-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  budgetizer: {
    vendorId: 1212110,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'bulk-edit-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'burn-up-chart': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'burndown.gadget.jira': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'capacity-tracker-plugin': {
    vendorId: 1215132,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  cello: {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ch.bitvoodoo.confluence.plugins.language': {
    vendorId: 28550,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ch.bitvoodoo.confluence.plugins.navitabs': {
    vendorId: 28550,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ch.bitvoodoo.confluence.plugins.panelbox': {
    vendorId: 28550,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ch.bitvoodoo.confluence.plugins.viewtracker': {
    vendorId: 28550,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ch.mibex.confluence.include': {
    vendorId: 1211511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ch.mibex.confluence.ipython-notebook': {
    vendorId: 1211511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'clockwork-cloud': {
    vendorId: 1215166,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'clockwork-free-cloud': {
    vendorId: 1215166,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'cloud-files-google-drive-docs-office-365-documents-dropbox-topdox-for-confluence': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'co.uk.jackgraves.classification.server-classification': {
    vendorId: 1213911,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'co.uk.jackgraves.jira-optimiser': {
    vendorId: 1213911,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'coji.deviniti.com': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com-softcomply-riskmanager-cloud': {
    vendorId: 1213743,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com-softcomply-riskmanager-plus': {
    vendorId: 1213743,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.adaptavist.cloud.search': {
    vendorId: 81,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.adaptavist.confluence.contentFormattingMacros': {
    vendorId: 81,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.adaptavist.confluence.formMailNG': {
    vendorId: 81,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.adaptavist.confluence.forums': {
    vendorId: 81,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.addonengine.analytics': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.addteq.confluence.plugin.unstoppable.unstoppable-confluence': {
    vendorId: 1210688,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.addteq.jira.plugin.accessibility.addteq-jira-unstoppable': {
    vendorId: 1210688,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.aelbox.scrumpy': {
    vendorId: 1215786,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.almworks.jira.structure': {
    vendorId: 7035,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.almworks.structure.gantt': {
    vendorId: 7035,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.alphaserve.authplugin': {
    vendorId: 1216274,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.alphaserve.bamboo.bamboo-authplugin': {
    vendorId: 1216274,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.alphaserve.bigquery-connector-jira': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.bitbucket.authplugin': {
    vendorId: 1216274,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.alphaserve.checklist.jira-checklist': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.cloud.azure': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.cloud.canva-confluence': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.cloud.canva-jira': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.cloud.ms-forms.confluence': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.confluence.authplugin': {
    vendorId: 1216274,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.alphaserve.crowd-authplugin': {
    vendorId: 1216274,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.alphaserve.gitapp.jira-git-integration': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.mail-me': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.powerbi-connector-jira': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.alphaserve.tableau-connector-jira': {
    vendorId: 1216274,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.amoeboids.apps.roadmap': {
    vendorId: 1211499,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.appliger.jira.templates': {
    vendorId: 1215504,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.apwide.timeline-plugin': {
    vendorId: 1211423,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.arijea.easy-agile-roadmaps': {
    vendorId: 1212045,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.assertthat.jira.bdd': {
    vendorId: 1215636,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlasauthority.mpp-to-jira': {
    vendorId: 1212980,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.admin-kit-for-confluence-cloud': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.admin-kit-for-jira-cloud': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.ams.shipit.tomcat-filter': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugin.bamboo-build-times-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugin.bamboo-predator-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugins.bamboo-announcement-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugins.bamboo-build-status-notifier': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugins.bamboo-conditional-tasks': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugins.deploy.continuous-plugin-deployment': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugins.sbt': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bamboo.plugins.variable.updater.variable-updater-generic': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bitbucket.code-coverage-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bitbucket.plugins.bitbucket-slack-server-integration-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.bitbucket.plugins.disable-referer.disable-referer-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.bitbucket.server.bitbucket-gvfs': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bitbucket.server.bitbucket-server-release-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bitbucket.server.bitbucket-xcode': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.bitbucket.slack': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.bonfire.plugin': {
    vendorId: 17834,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.cloud.hackathon': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.emcee': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.extra.graphviz': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.extra.team-calendars': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.confluence.plugin.copyspace': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.plugins.atlassian-playbook-blueprints': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.plugins.confluence-mobile-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.confluence.plugins.confluence-office365': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.plugins.confluence-questions': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.confluence.plugins.confluence-slack-server-integration-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.confluence.plugins.editor.confluence-source-editor': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.plugins.favorites-dialog-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.confluence.plugins.reconcile-unknown-attachments': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.confluence.sketchfab-connect': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.connect.better-code-macro.prod': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.connect.entity-property-tool.prod': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.cpji.cpji-jira-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.cps.sumUp': {
    vendorId: 1210905,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.crucible.plugins.crucible-mandatory-reviewers-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.crucible.plugins.crucible-transfer-project': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.fecru-github-integration-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.crucible-build-status': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.fecru-batch-frx-management-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.fecru-copy-source-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.fecru-look-and-feel-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.fecru-paste-image-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.fecru-repoquickadd-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.fecru-revset-report-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fecru.plugins.frxtag.crucible-frxtag-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.fisheye.repositron': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.formbuilder': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jconnect.jconnect-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.confluence-issue-tab-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.emcee': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.ext.calendar': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.ext.charting': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.jira-autolink-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.migration.jira-migration-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.jira.mobile.jira-mobile-rest': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.jira.plugin.jirasslplugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugin.quickreload': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.bitbucketpipelines': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.excel': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.jenkins': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.jira-cloud-compatibility-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.jira-data-generator': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.jira-importers-asana-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.plugins.jira-slack-server-integration-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.jira.plugins.workflow.jira-workflow-screenshot-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.slack': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.spreadsheets': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.stika': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.toolkit': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jira.trello': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.jira.trello.jello': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.jiraalign.jet': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.jpos.confluencemacro.portfolio-sever-confluence-macro': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.labs.bitbucket.bitbucket-permissions-lockdown-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.labs.crowd.directory-pruning-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.labs.rest-api-browser': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.migration.agent': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.migration.datacenter.jira-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.myreminders': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.opsgenie.opsgenie-bamboo-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.plugin.automation.jira-automation-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.plugins.authentication.atlassian-authentication-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.plugins.confluence.markdown.confluence-markdown-macro': {
    vendorId: 1212980,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.plugins.confluence.okrbp.okrbp': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.plugins.panopticon': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.plugins.reviewcreator': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.servicedesk.change': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.servicedesk.embedded': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.atlassian.shipit.bb-reviewer-group': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.stash.backup.client': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.stash.plugin.stash-archive': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.stash.plugin.stash-auto-unapprove-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.stash.plugin.stash-inbox-hook': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.stash.plugin.stash-look-and-feel-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.stash.plugin.stash-protect-unmerged-branch-hook': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.stash.plugin.stash-suggest-reviewers': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.stash.plugin.stash-web-post-receive-hooks-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.troubleshooting.plugin-bamboo': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.troubleshooting.plugin-confluence': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.troubleshooting.plugin-crowd': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.troubleshooting.plugin-fecru': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassian.troubleshooting.plugin-jira': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassian.upm.atlassian-universal-plugin-manager-plugin': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.atlassianlab.bamboo.plugins.bamboo-after-deployment-trigger-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassianlab.bamboo.plugins.bamboo-agent-notification-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassianlab.bamboo.plugins.bamboo-agents-usage': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassianlab.bamboo.plugins.bamboo-fail-trigger': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassianlab.bamboo.plugins.bamboo-queue-priority-plugin': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.atlassianlabs.bamboo.plugins.dependency.graph': {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.automation-consultants.accloud.approvalmacro': {
    vendorId: 1213911,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.automation-consultants.accloud.workflows': {
    vendorId: 1213911,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.awnaba.projectconfigurator.projectconfigurator': {
    vendorId: 81,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.balsamiq.confluence.plugins.mockups': {
    vendorId: 88,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.balsamiq.jira.plugins.mockups': {
    vendorId: 88,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.balsamiq.mockups.confluence': {
    vendorId: 88,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.balsamiq.mockups.jira': {
    vendorId: 88,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.bigbrassband.jira_dev_info': {
    vendorId: 1210545,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.bilith.lref.confluence-asana': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.bilith.lref.confluence-box': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.bilith.lref.confluence-gdrive': {
    vendorId: 1217380,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.boja.riskregister.addon': {
    vendorId: 1215075,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.bolo.conf.numhead': {
    vendorId: 1210571,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.brizoit.companycalendar': {
    vendorId: 1210728,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.caelor.cloud.todo-checklist': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.caelor.confluence.cloud.cards-panels': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codebarrel.addons.automation': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.codebarrel.jira.iconselectlist': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.codecanvas.glass': {
    vendorId: 4907,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.asset-sync-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.comment-history-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.comment-tools-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.deep-clone-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.external-custom-fields-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.merge-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.project-sync-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.codefortynine.quick-filters-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.comalatech.adhoccanvas': {
    vendorId: 94,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.comalatech.canvas': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.comalatech.cloud.approvals': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.comalatech.jira.agile-ranking': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.comalatech.jira.canvas': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.comalatech.publishing': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.comalatech.rc': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.comalatech.workflow': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.comalatech.workflow.approvals': {
    vendorId: 94,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.communardo.confluence.metadata': {
    vendorId: 95,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.cprime.atlas.sil.extension.groovy-runner.sil-groovy-runner': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.atlassian.plugins.prom-confluence-exporter': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.cprime.bamboo.plugins.globalsso-for-bamboo': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.cprime.bitbucket.plugins.globalsso-for-bitbucket': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.confluence.plugins.globalsso-for-confluence': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.confluence.plugins.kb-searcher-confluence': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.confluence.power-scripts-confluence': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.fecru.plugins.globalsso-for-fecru': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.cprime.jira.plugins.globalsso-for-jira': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.jira.plugins.reporting': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.jira.plugins.safe-translator': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.jira.plugins.sfdc': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.cprime.jira.plugins.surveyproject': {
    vendorId: 1211168,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deiser.jira.exporter': {
    vendorId: 27570,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deiser.jira.profields': {
    vendorId: 27570,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deniz.jira.reminders': {
    vendorId: 1211057,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deviniti.atlassian.apps.azure-sync': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deviniti.atlassian.apps.extension-myrequests': {
    vendorId: 1216051,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deviniti.atlassian.apps.rtm': {
    vendorId: 1216051,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.deviniti.atlassian.apps.trophy': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deviniti.context-issues': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.deviniti.jira.issuesync': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.devsamurai.plugin.jira.story-mapping': {
    vendorId: 1216701,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.devsamurai.plugin.jira.team-board': {
    vendorId: 1216701,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.digitaltoucan.goalfocus': {
    vendorId: 1212968,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.digitaltoucan.okrforjira': {
    vendorId: 1212968,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.digitaltoucan.panorama': {
    vendorId: 1212968,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.docminer.jira.issue-links': {
    vendorId: 1210926,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.easyagile.personas': {
    vendorId: 1212045,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.easyagile.programs': {
    vendorId: 1212045,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.eazybi.confluence.plugins.eazybi-confluence': {
    vendorId: 866502,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.eazybi.jira.plugins.eazybi-jira': {
    vendorId: 866502,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.elements.publish.create-confluence-page-from-jira': {
    vendorId: 4952,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.elements.publish.create-confluence-page-from-jira.helper-app': {
    vendorId: 4952,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.exalate.ccnode': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.exalate.githubnode': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.exalate.hpqcnode': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.exalate.jiranode': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'com.exalate.snownode': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.exalate.zendesk': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.fca.jira.plugins.workflowToolbox.workflow-toolbox': {
    vendorId: 1210905,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.feedthree.jsd.smartqueues': {
    vendorId: 1215927,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.gebsun.atlassian.reports': {
    vendorId: 1210675,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.gebsun.atlassian.rtasks': {
    vendorId: 1214719,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.gebsun.plugins.jira.issuechecklist': {
    vendorId: 1215166,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.github.integration.production': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.gliffy.integration.confluence': {
    vendorId: 99,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.gliffy.integration.jira': {
    vendorId: 99,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.googlecode.jira-suite-utilities': {
    vendorId: 42620,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.herocoders.plugins.jira.issuechecklist-free': {
    vendorId: 1215166,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.holydev.env.plugin.jira-holydev-env-plugin': {
    vendorId: 1211423,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.innovalog.jmwe.jira-misc-workflow-extensions': {
    vendorId: 101,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.intenso.jira.issue-templates': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.intenso.jira.plugins.jsd-extender': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.intenso.jira.plugins.synchronizer': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.intenso.jira.queues-extension': {
    vendorId: 39038,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.izymes.organizr': {
    vendorId: 1210584,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.izymes.workzone': {
    vendorId: 1210584,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.javahollic.jira.jemh-ui': {
    vendorId: 1210712,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.jiraworkcalendar.work-calendar': {
    vendorId: 1210728,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.k15t.backbone.backbone-issue-sync': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'com.k15t.scroll.scroll-exporter-extensions': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.k15t.scroll.scroll-html': {
    vendorId: 7016,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.k15t.scroll.scroll-office': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'com.k15t.scroll.scroll-pdf': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'com.k15t.scroll.scroll-translations': {
    vendorId: 7016,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.k15t.scroll.scroll-versions': {
    vendorId: 7016,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.k15t.scroll.scroll-viewport': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.kaanha.jira.tcms': {
    vendorId: 1211784,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.kanoah.test-manager': {
    vendorId: 17834,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.keplerrominfo.jira.plugins.blitz-actions': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.keplerrominfo.jira.plugins.commons': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.keplerrominfo.jira.plugins.databasecf': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.keplerrominfo.jira.plugins.jjupin': {
    vendorId: 1211168,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.keplerrominfo.jira.plugins.keplercf': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.keplerrominfo.jira.plugins.sil-tempo': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'com.kintosoft.jira.birt_viewer': {
    vendorId: 1210926,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.kintosoft.jira.ondemand.links': {
    vendorId: 1210926,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.kintosoft.jira.subversion-plus': {
    vendorId: 1210926,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.kintosot.jira.jdbc4jql': {
    vendorId: 1210926,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.kretar.jira.plugin.user-story-map': {
    vendorId: 1212045,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.madein49.google-calendar-for-confluence': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.madein49.slack-for-confluence': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.marvelution.jira.plugins.jenkins': {
    vendorId: 11178,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.metainf.jira.plugin.emailissue': {
    vendorId: 4907,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mobilitystream.jira.excelonline4jiracloud': {
    vendorId: 1210676,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mobilitystream.jira.google4jiracloud': {
    vendorId: 1210676,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.mohamicorp.confluence.macro.github.mohamicorp-github-macros': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mohamicorp.html.source.editor.for.confluence': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mohamicorp.plugin.autowatch.autowatch-for-jira': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.msteams-atlassian.bitbucket': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mumosystems.abacus': {
    vendorId: 1212550,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mute.confluence.plugins.lms': {
    vendorId: 1214340,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mute.confluence.plugins.terms': {
    vendorId: 1214340,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mxgraph.confluence.plugins.diagramly': {
    vendorId: 1210578,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.mxgraph.confluence.plugins.plantuml': {
    vendorId: 1217075,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.mxgraph.jira.plugins.drawio': {
    vendorId: 1210578,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.nurago.confluence.plugins.treecopy': {
    vendorId: 84,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.obss.plugin.time-in-status': {
    vendorId: 616898,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.okapya.jira.checklist': {
    vendorId: 1210673,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.oldstreetsolutions.atlassian.confluence.custom-charts': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.oldstreetsolutions.atlassian.jira.custom-charts': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.onresolve.bamboo.groovy.groovyrunner': {
    vendorId: 81,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.onresolve.confluence.groovy.groovyrunner': {
    vendorId: 81,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.onresolve.jira.groovy.groovyrunner': {
    vendorId: 81,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.onresolve.stash.groovy.groovyrunner': {
    vendorId: 81,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.pawelniewiadomski.jira.confluence-openid-authentication-plugin': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.pawelniewiadomski.jira.jira-openid-authentication-plugin': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.playsql.requirementyogi': {
    vendorId: 1210634,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.playsql.requirementyogijira': {
    vendorId: 1210634,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.projectbalm.riskregister.riskregister-jira': {
    vendorId: 1211840,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.radiantminds.roadmaps-jira': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.redmoon.customfields.jira': {
    vendorId: 1210925,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.redmoon.linkedrelationships.jira': {
    vendorId: 1210925,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.redmoon.projectwatcher.jira': {
    vendorId: 1210925,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.redmoon.subtaskmanager.jira': {
    vendorId: 1210925,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.redmoon.subtaskmanagerlite.jira': {
    vendorId: 1210925,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.redmoon.transitionmanager.jira': {
    vendorId: 1210925,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.refinedwiki.cloud.refinedsites': {
    vendorId: 15228,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.refinedwiki.confluence.cloud.refinedtheme': {
    vendorId: 15228,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.reliex.activitytimeline.cloud.atlassian.connect': {
    vendorId: 1210572,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.resolution.atlasplugins.samlsso-bamboo': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.resolution.atlasplugins.samlsso-bitbucket': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.resolution.atlasplugins.samlsso.Confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.resolution.atlasplugins.samlsso.Jira': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.confluence.plugins.insight-confluence': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-aws-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-azure-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-device42-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-discovery': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-googlecloud-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-sccm-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-servicenow-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-snow-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight-tempo-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.insight.insight-atlassian-environments': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.notificationassistant': {
    vendorId: 1212980,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.riadalabs.jira.plugins.userdeactivator': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.servicerocket.confluence.salesforce': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.servicerocket.jira.salesforce': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.servicerocket.jiraservicedesk.salesforce': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.simple-reports.affinity': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.simple-reports.planning': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.simplenia.confluence.plugins.imageslider': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.simplenia.confluence.plugins.newsteaser': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.simplenia.confluence.plugins.polls': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.smartbear.cucumber': {
    vendorId: 17834,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.smartbear.ze.jiraplugin': {
    vendorId: 17834,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.sngtec.jira.cloud.exporter': {
    vendorId: 1212050,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.soldevelo.apps.checklists': {
    vendorId: 1215650,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.soldevelo.apps.worklogs': {
    vendorId: 1215650,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.spartez.jira.plugins.bork.tfs4jira': {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.spartez.jira.plugins.commenttemplates': {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.spartez.jira.plugins.jiraplanningpoker': {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.spartez.jira.plugins.support-chat': {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.spartez.scrumprint.scrumplugin': {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.confluence.cloud.webhooks': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.confluence.handy.macros': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.confluence.plugin.tablefilter.tablefilter': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.stiltsoft.confluence.quiz': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.jira.cloud.issueworksheet': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.jira.cloud.project-performance-dashboard-addon': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.jira.smart-attachments': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.jira.teamcity': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stiltsoft.stash.graphs': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.stonikbyte.great.gadgets.plugin': {
    vendorId: 1210523,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.stonikbyte.great.gadgets.server': {
    vendorId: 1210523,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.stonikbyte.jira.plugins.project-docs-plugin': {
    vendorId: 1210523,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.sysbliss.bamboo.plugins.prepost-build-command': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'com.tempoplugin.tempo-planner': {
    vendorId: 6558,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.tensixtwo.conf.latexmath': {
    vendorId: 1210571,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.tensixtwo.conf.latexmath-lite': {
    vendorId: 1210571,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.tensixtwo.conf.numcapt': {
    vendorId: 1210571,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'com.thed.zephyr.je': {
    vendorId: 17834,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.thinktilt.proforma.add-on': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.thinktilt.proforma.lite.add-on': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.ugubi.streams.filtersactivitystream': {
    vendorId: 1212110,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.valiantys.jira.plugins.SQLFeed': {
    vendorId: 4952,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.valiantys.jira.plugins.exocet.jira-plugin-exocet-pro': {
    vendorId: 4952,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.valiantys.software.elements': {
    vendorId: 4952,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.valiantys.spreadsheets': {
    vendorId: 4952,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.view26.servicedesk-report.jira': {
    vendorId: 1214029,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.wittified.atl-announcer-confluence': {
    vendorId: 1210682,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'com.xiplink.jira.git.jira_git_plugin': {
    vendorId: 1210545,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.xpandit.plugins.jiraxporter': {
    vendorId: 31085,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.xpandit.plugins.xray': {
    vendorId: 31085,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.yasoon.calendar': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.yasoon.connect.addon': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'com.yasoon.jira.cloud': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'com.yasoon.jira.light': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'confluence-chats-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-cloud-for-microsoft-teams': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-github-link-macro': {
    vendorId: 1213354,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-google-drive': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-microsoft-teams-connector': {
    vendorId: 1213354,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-microsoft-teams-connector-lite': {
    vendorId: 1213354,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-slack-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence-tree-search-add-on': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'confluence.halp.com': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'cr.tin.ActiveUserFilter.active-user-filter': {
    vendorId: 1212980,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'cr.tin.iframed.iframed-macro': {
    vendorId: 1212980,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'customer-case-for-jira': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.communardo.confluence.plugins.csi': {
    vendorId: 95,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.communardo.confluence.plugins.subspace': {
    vendorId: 95,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.communardo.confluence.plugins.userprofile': {
    vendorId: 95,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.dl.confluence.plugin.imagemap.ImageMapPlugin': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'de.resolution.apitokenauth.confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.apitokenauth.jira': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.cloud.analytics.google': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.httpheaderauth.confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.httpheaderauth.jira': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.integration.hubspot-crm-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.invision-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.microsoft-powerbi-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.miro-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.monday-com-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.monday-com-for-jira': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.pdf-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.smartsheet-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.survey-monkey-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.typeform-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.integration.zoom-recordings-for-confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.jsdlangtools': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'de.resolution.jsdreadreceipts': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'de.resolution.user-deactivator.bitbucket': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'de.resolution.user-deactivator.confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.usersync.bamboo': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'de.resolution.usersync.bitbucket': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.usersync.confluence': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.usersync.jira': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'de.resolution.vanityurl': {
    vendorId: 1210947,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  delibr: {
    vendorId: 1215586,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'delibr-confluence': {
    vendorId: 1215586,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'doitbetter.calendar': {
    vendorId: 1215246,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'dropbox-confluence': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'dropbox-files-document-connector-addon-plugin-for-confluence-topdox': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'dropbox-gadgets-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'dropbox-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'dynamic-fields-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'egnyte-connector-addon-plugin-for-confluence-topdox': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'electronic-signing-cc': {
    vendorId: 1214923,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'employee-ratings-addon': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'eps.focuspro.PageTreeCreator': {
    vendorId: 1212298,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'eps.focuspro.SpaceTreeCreator': {
    vendorId: 1212298,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'es.excentia.jira.plugins.jira-sonarqube-connector-plugin': {
    vendorId: 1210681,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'eu.softwareplant.biggantt': {
    vendorId: 1211388,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'eu.softwareplant.bigpicture': {
    vendorId: 1211388,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'eu.wisoft.gantt-ondemand': {
    vendorId: 1210999,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'eu.wisoft.slack.confluence': {
    vendorId: 1210999,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'eu.wisoft.slack.jira': {
    vendorId: 1210999,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'expert.marketplace.jira.eclipse.equinox4jira': {
    vendorId: 1210926,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'external-data-for-confluence': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  foxly: {
    vendorId: 1215681,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'google-calendar-confluence': {
    vendorId: 1217380,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'google-calendar-jira': {
    vendorId: 1217380,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'google-drive-docs-documents-for-confluence': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'google-drive-gadgets-jira': {
    vendorId: 1217380,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'google-drive-jira': {
    vendorId: 1217380,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'halp.com': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'hiptest.jira-plugin': {
    vendorId: 1211678,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'iframe-dashboard-gadget-jira': {
    vendorId: 1212980,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'individual.velocity.gadget.jira': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'instant-websites': {
    vendorId: 1210637,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'io.ativo.plugins.agile-programs-for-jira': {
    vendorId: 1217966,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'io.riada.jira.plugins.insight-cve-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'io.riada.jira.plugins.insight-jamf-integration': {
    vendorId: 85,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'io.tempo.cost-tracker': {
    vendorId: 6558,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'io.toolsplus.atlassian.connect.jira.intercom': {
    vendorId: 1214275,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'is.origo.jira.tempo-plugin': {
    vendorId: 6558,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'issue-history': {
    vendorId: 1216118,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jamf-for-jira': {
    vendorId: 1213041,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'javascript-charts-for-jira-cloud': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-crm-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-github-links': {
    vendorId: 1213354,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-microsoft-teams-connector': {
    vendorId: 1213354,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-outlook-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-sheets-official': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-slack-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-timesheet-plugin': {
    vendorId: 120,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jira-trello-integration': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  jiracustomfieldeditorplugin: {
    vendorId: 1210693,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  jmeterAggregator: {
    vendorId: 33202,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'jp.ricksoft.plugins.excel4jira': {
    vendorId: 29695,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jp.ricksoft.plugins.wbsgantt-for-jira': {
    vendorId: 29695,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'jql-extensions': {
    vendorId: 1212968,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'jsd-status-page': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'k15t-scroll-document-versions-for-confluence': {
    vendorId: 7016,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'lagom-flow': {
    vendorId: 1216058,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'launchdarkly-jira': {
    vendorId: 1213661,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'logjira.jira': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'meetical-connect-app': {
    vendorId: 1217198,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'microsoft-teams': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'mohamicorp-render-markdown': {
    vendorId: 1211979,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.artemissoftware.confluence.flowboard.FlowBoard': {
    vendorId: 84,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.caelor.jira.cloud.moscow': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.collabsoft.plugins.stash.gfc': {
    vendorId: 1210574,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.customware.confluence.plugin.composition': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.customware.confluence.plugin.linking': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.customware.confluence.plugin.redirection': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.customware.confluence.plugin.scaffolding': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.customware.confluence.plugin.vault': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.customware.confluence.plugin.visibility': {
    vendorId: 96,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.oharagroup.confluence.plugins.confluence-open-api': {
    vendorId: 1212012,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.seibertmedia.confluence.appcenter': {
    vendorId: 9093,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.seibertmedia.confluence.collapsable-admin-menu': {
    vendorId: 9093,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.seibertmedia.confluence.enterprise-news-bundle': {
    vendorId: 9093,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.seibertmedia.confluence.language-manager': {
    vendorId: 9093,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.seibertmedia.plugin.confluence.event-manager': {
    vendorId: 9093,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.seibertmedia.plugin.confluence.microblog': {
    vendorId: 9093,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'net.vacom.jirassimo': {
    vendorId: 1212475,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.confluence.cloud.macrosuite': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.confluence.cloud.translator': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.confluence.cloud.trophies4c': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.jira.cloud.image.editor': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.jira.cloud.themebuilder': {
    vendorId: 1214927,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.jira.cloud.trophies4j': {
    vendorId: 1219251,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.veniture.jira.vLinks': {
    vendorId: 1214927,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'net.vicox.confluence.plugins.gravatar': {
    vendorId: 1212980,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'nextup-helpdesk-plus': {
    vendorId: 1214995,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.avisi.confluence.plugins.atlas-crm': {
    vendorId: 16045,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.avisi.confluence.plugins.numberedheadings': {
    vendorId: 16045,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.avisi.confluence.plugins.xsdviewer': {
    vendorId: 16045,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.avisi.jira.plugins.edit-custom-field-values': {
    vendorId: 16045,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.avisi.jira.plugins.relations-for-jira': {
    vendorId: 16045,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.avisi.topdesk': {
    vendorId: 16045,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'nl.stefankohler.stash.stash-notification-plugin': {
    vendorId: 23324,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'no.kantega.kerberosauth.kerberosauth-plugin': {
    vendorId: 1211151,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'no.kantega.kerberosauth.kerberosauth-plugin.bamboo': {
    vendorId: 1211151,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'no.kantega.kerberosauth.kerberosauth-plugin.confluence': {
    vendorId: 1211151,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'no.kantega.kerberosauth.kerberosauth-plugin.fecru': {
    vendorId: 1211151,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'no.kantega.kerberosauth.kerberosauth-plugin.stash': {
    vendorId: 1211151,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'octo-jexo-component-management': {
    vendorId: 1215681,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  okrplugin_prod: {
    vendorId: 1216356,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'onedrive-business-connector-addon-plugin-for-confluence-topdox': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'onedrive-confluence': {
    vendorId: 1217319,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'onedrive-gadgets-jira': {
    vendorId: 1217319,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'onedrive-jira': {
    vendorId: 1217319,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'opsgenie-incident-timeline-eu': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'opsgenie-incident-timeline-prod': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'opsgenie-jira-adapter': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.andya.confluence.plugins.metadata': {
    vendorId: 94,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'org.everit.jira.timetracker.plugin': {
    vendorId: 1210702,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.hotovo.sketch-confluence': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.confluence.cli': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.confluence.excel': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.confluence.html': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.confluence.markdown': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.confluence.table': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.jira.cli': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.jira.clone-plus': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.swift.jira.cot': {
    vendorId: 90,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.techtime.confluence.plugins.googlemapsembed': {
    vendorId: 111,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'org.techtime.jira.plugins.easytime': {
    vendorId: 111,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'outlook-calendar-confluence': {
    vendorId: 1217319,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'outlook-calendar-jira': {
    vendorId: 1217319,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'outofoffice-connect': {
    vendorId: 1210947,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.atlasinc.confluence.board': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.atlasinc.confluence.confluence-share': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ovh.atlasinc.confluence.confluence-share-lite': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.atlasinc.jira.jira-mail': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.atlasinc.jira.jira-share': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'ovh.atlasinc.jira.jira-share-lite': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.atlassianinc.approval-path.jira': {
    vendorId: 1216408,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.giphy': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.latex': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.qr': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.qrcode': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.remote': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.snip': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.spoiler': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.confluence.video': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ovh.dwa.jira.jira-analytics': {
    vendorId: 1214946,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  'performance-objectives-for-jira': {
    vendorId: 1215335,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'pl.com.tt.jira.plugin.theschedulerpro': {
    vendorId: 37453,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'polling-macro': {
    vendorId: 1213911,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'portfolio-forecaster': {
    vendorId: 1216058,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  prevnextnav: {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'priority-scoring-calculator-plugin': {
    vendorId: 1212110,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'pro.behave.bitbucket.app': {
    vendorId: 1210580,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'pro.behave.hosted': {
    vendorId: 1210580,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'pwc-confluence-addon': {
    vendorId: 1213059,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  quantify: {
    vendorId: 1215519,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'quantify-subscription': {
    vendorId: 1215519,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'refined.cloud.confluence': {
    vendorId: 15228,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'rich-text-gadget': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ru.andreymarkelov.atlas.plugins.datacollector': {
    vendorId: 1211168,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'ru.andreymarkelov.atlas.plugins.prom-bamboo-exporter': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'ru.andreymarkelov.atlas.plugins.prom-bitbucket-exporter': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'ru.andreymarkelov.atlas.plugins.prom-confluence-exporter': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'ru.andreymarkelov.atlas.plugins.prom-jira-exporter': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'ru.andreymarkelov.atlas.plugins.prom-jira-exporter-lite': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: false
    }
  },
  'ru.andreymarkelov.atlas.plugins.signaturefields': {
    vendorId: 1211168,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: true
    }
  },
  'ru.andreymarkelov.atlas.plugins.utils': {
    vendorId: 1211168,
    hosting: {
      cloud: false,
      server: false,
      dataCenter: true
    }
  },
  'ru.teamlead.jira.plugins.reminder-for-jira': {
    vendorId: 22223,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'rw-smart-checklist-biz': {
    vendorId: 1213126,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'rw-smart-checklists': {
    vendorId: 1213126,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'scrum-poker-jira': {
    vendorId: 1213059,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'see-all-unresolved-comments': {
    vendorId: 1211565,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'simple.reports.jira': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'slack.nextup.jira': {
    vendorId: 1214995,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'softwareplant.bigpictureenterprise': {
    vendorId: 1211388,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'softwareplant.bigtemplate': {
    vendorId: 1211388,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'stspg-jira-ops': {
    vendorId: 85,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'swanly-jexo-release-management': {
    vendorId: 1215681,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'tableau-for-confluence': {
    vendorId: 1212980,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'tableau-plugin': {
    vendorId: 1212980,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'team-files-office-google-drive-365-for-jira': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'team-files-office-sharepoint-excel-365-for-jira': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'team-files-office-sharepoint-excel-google-drive-365-for-jira': {
    vendorId: 1213047,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'tge.cloud': {
    vendorId: 22511,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: false
    }
  },
  threadedcomments: {
    vendorId: 1212110,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'tig.jira.extension.tigEpicTimeTrackingExtension': {
    vendorId: 1215249,
    hosting: {
      cloud: false,
      server: true,
      dataCenter: true
    }
  },
  'time-in-status-report': {
    vendorId: 1216118,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'time.tracking.reports.jira': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'tss-simple-agile-boards': {
    vendorId: 1210684,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'user-profiles-addon': {
    vendorId: 27437,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'weekly.status.report.jira': {
    vendorId: 1215481,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  whiteboards: {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'whiteboards-confluence': {
    vendorId: 7755,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'whoslooking-connect': {
    vendorId: 33202,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'wrike-confluence': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'wrike-gadgets-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'wrike-jira': {
    vendorId: 1213750,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'yasoon-confluence-meetings': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'yasoon-jira-teams': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  },
  'yasoon-jira-todo': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: false,
      dataCenter: false
    }
  },
  'yasoon-jsd-meeting': {
    vendorId: 1211722,
    hosting: {
      cloud: true,
      server: true,
      dataCenter: true
    }
  }
};